import env from '../env';

export default {
	UPDATE_SKETCH_DOCUMENT: `${env.API_INVENTORY}SketchRequest/ResubmitSketch`,
	GET_SKETCH_DATA_BY_ID: `${env.API_VIEWER}Virtuoso/GetSketchRequestByID`,
};
